<template>
  <!-- 会员卡系列 -->
  <div class="special-offers">
    <!-- 大标题 -->
    <!-- 活动详情 -->
    <div class="activity-details" @click="cardsDetailsBtn(item.id)" v-for="(item,index) in member_card_List" :key="index" style="cursor:pointer">
      <!-- 活动标题 -->
      <div class="activity-details-title">
        <p class="activity_name">
          {{item.name}}
        </p>
        <span v-for="(item1,index1,) in item.lable" :key="index1" :class="tagStyle(index1)" class="tag">
          {{item1}}
        </span>
        <p class="price">
          <span>价格:{{item.pcate}}</span>
          
          <!-- <span>会员价:{{item.pcate}}</span> -->
        </p>
      </div>
      <!-- 活动介绍 -->
      <p class="activity-details-introduce">
        {{item.desc}}
      </p>
      <div class="activity-details-img">
        <img :src=item.thumbnil alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  props:[
    'member_card_List'
  ],
  methods:{
    // 标签样式
    tagStyle(index){
      return "person_" + index
    },
    //会员卡详情
    cardsDetailsBtn(id){
      this.$router.push({
        path:'/card-ecommend',
        query:{
          id : id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  // 特价活动
  .special-offers{
    width: 100%;
    // height: 100%;
    // display: flex;
    // flex-direction: column;
    // overflow: scroll;
    // flex: 1;
    margin-top: .2rem;
    // 大标题
    // 活动详情
    .activity-details{
      width: 6.92rem;
      height: 5.18rem;
      margin: 0 auto;
      border-radius: .1rem;
      box-shadow:0rem 0.01rem 0.1rem 0rem rgba(0,0,0,0.22);
      overflow: hidden;
      margin-bottom: .2rem;
      // 活动标题
      .activity-details-title{
        width: 100%;
        height: .44rem;
        display: flex;
        align-items: center;
        margin-top: .22rem;
        // 标题
        .activity_name{
          font-family: PingFang-SC-Bold;
          font-size: .32rem;
          line-height: .32rem;
          color: #333333;
          font-weight: bold;
          margin-left: .2rem;
        }
        // 标签
        .tag{
          display: inline-block;
          width: .48rem;
          height: .24rem;
          font-size: .16rem;
          line-height: .24rem;
          color: #ffffff;
          border-radius:0.04rem;
          text-align: center;
        }
        // 样式
        .person_0{
          background: #FF0000;
          margin-left: .1rem;
        }
        .person_1{
          background: #7FBE39;
          margin-left: .04rem;
        }
        .price{
          span{
            font-family: PingFang-SC;
            &:first-child{
              font-size: .18rem;
              margin-left: .1rem;
              color: #999999;
            }
            &:last-child{
              font-size: .18rem;
              margin-left: .1rem;
              color: #333333;
            }
          }
        }
      }
      // 活动介绍
      .activity-details-introduce{
        font-family: PingFang-SC;
        color: #666666;
        font-size: .24rem;
        line-height: .24rem;
        margin-top: .2rem;
        margin-left: .2rem;
      }
      // 图片
      .activity-details-img{
        width: 6.52rem;
        height: 3.14rem;
        margin: 0 auto;
        margin-top: .42rem;
        img{
          width: 6.52rem;
          height: 3.7rem;
        }
      }
    }
  }
</style>